<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-list mr-2" />SPK Baru</h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="Serial Number">
                        <b-input-group>
                            <b-form-input placeholder="SN" v-model="input.sn" @keydown.enter="searchInven" />
                            <b-input-group-append>
                                <b-button variant="primary" @click="searchInven" :disabled="isSubmitting">
                                    <i class="fa fa-search mr-2" /> Cari
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Jenis SPK">
                        <b-form-select v-model="input.workType">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Pilih Jenis SPK</b-form-select-option>
                            </template>
                            <b-form-select-option :value="$enums.SpkWorkType.REPAIR">REPAIR</b-form-select-option>
                            <b-form-select-option :value="$enums.SpkWorkType.QC">QC</b-form-select-option>
                            <b-form-select-option :value="$enums.SpkWorkType.DISMANTLE">DISMANTLE</b-form-select-option>
                            <b-form-select-option :value="$enums.SpkWorkType.ASSEMBLY">ASSEMBLY</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="inven.id != null">
                <b-col>
                    <b-card>
                        <strong>Unit untuk Perbaikan</strong>
                        <div>{{ inven.category }} - SN {{ inven.sn }}</div>
                        {{ inven.type }} - {{ inven.manufacturer }} {{ inven.search1 ? "- " + inven.search1 : "" }}
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Ex. Wilayah">
                        <multiselect v-model="input.wilayah"
                            :options="optWilayah"
                            :allow-empty="false"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="Wilayah"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Ex. Lokasi">
                        <multiselect v-model="input.lokasi"
                            :options="optLokasi"
                            :allow-empty="false"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="Lokasi"
                            :disabled="input.wilayah == null"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-form-group label="Catatan / Status" :description="input.statusCatatan.length + ' / 500'">
                <b-form-textarea v-model="input.statusCatatan" maxlength="500"
                    rows="5" max-rows="10"
                    placeholder="Catatan / Status SPK"
                />
            </b-form-group>
            <b-button variant="primary" @click="openConfirmModal">
                <i class="fa fa-save mr-2" /> Buat dan Simpan SPK
            </b-button>
        </b-card>
        <b-modal id="modal-confirm" title="Konfirmasi Pembuatan SPK Baru" hide-footer no-close-on-backdrop no-close-on-esc centered>
            <div class="mb-3">
                Konfirmasi pembuatan SPK untuk unit ini? Status unit akan berubah menjadi REPAIR!
            </div>
            <div class="text-right">
                <b-button variant="primary" @click="submitSpk" :disabled="isSubmitting">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'spk-create',
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            bypassLeave: false,

            input: {
                sn: "",
                wilayah: null,
                lokasi: null,
                statusCatatan: "",
                workType: null
            },

            inven: {},

            search: {
                sn: "",
                category: null,
            },

            optWilayah: [],
            optLokasi: []

        }
    },
    methods: {

        init() {

            this.initStatus = 0

            let getWilayah = this.$axios.get("wilayah/selection").then(res => {
                this.optWilayah = res.data
            })

            // let getCategory = this.$axios.get("plan/get-category").then(res => {
            //     this.optCategory = res.data.map(it => { return { value: it.id, text: it.name } })
            // })

            Promise.all([getWilayah]).then(res => {
                this.initStatus = 1
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.initStatus = -1
            })

        },

        searchInven() {

            this.isSubmitting = true

            let payload = new FormData()
            payload.append("sn", this.input.sn)

            this.$axios.post("spk/get-inventory", payload).then(res => {
                this.inven = res.data
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        openConfirmModal() {

            if(this.input.workType == null) {
                return this.$helper.toastError(this, "Mohon memilih Jenis SPK!")
            }

            if(this.input.lokasi == null) {
                return this.$helper.toastError(this, "Mohon mengisi Ex. Lokasi!")
            }

            if(this.inven.id == null) {
                return this.$helper.toastError(this, "Mohon memilih unit!")
            }

            this.$bvModal.show("modal-confirm")

        },

        submitSpk() {

            let payload = new FormData()
            payload.append("inventoryId", this.inven.id)
            payload.append("exLokasiId", this.input.lokasi.id)
            payload.append("statusCatatan", this.input.statusCatatan)
            payload.append("workType", this.input.workType)

            this.isSubmitting = true
            this.$axios.post("spk/", payload).then(res => {

                let id = res.data.id
                this.bypassLeave = true
                this.$router.push("/spk/" + id)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        }

    },
    watch: {

        "input.wilayah": function(newVal) {

            this.input.lokasi = null

            if(newVal == null) {
                return
            }

            this.$axios.get("lokasi/selection/" + newVal.id + "?all=true").then(res => {
                this.optLokasi = res.data
            })

        }

    },
    created() {
        this.init()
    },
    beforeRouteLeave(to, from, next) {

        if(this.input.id != null && !this.bypassLeave) {

            const answer = window.confirm('Tinggalkan halaman ini?')
            if(answer) {
                next()
            }
            else {
                next(false)
            }

        }
        else {
            next()
        }

    }
}
</script>
